var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _rect2, _rect3, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 201,
    viewBox: "0 0 160 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36238_20641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 201
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.671875,
    width: 160,
    height: 200,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36238_20641)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0738 113.232C98.0037 117.836 100.002 129.109 104.62 139.272V153.342H79V110.292L98.0738 113.232ZM59.926 113.232C59.9962 117.836 57.9978 129.109 53.3799 139.272V153.342H78.9999V110.292L59.926 113.232Z",
    fill: "#BFBEFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8601 42.4614H106.72L108.61 75.4314C108.61 75.4314 109.55 99.1083 102.1 110.921C95.4836 121.412 90.7731 129.401 78.3701 129.401C65.967 129.401 61.1401 121.328 54.6401 110.921C47.4944 99.4808 48.3401 76.6914 48.3401 76.6914L50.8601 42.4614Z",
    fill: "#BFBEFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3468 76.2716L46.684 48.083C46.2285 40.3625 52.3668 33.8516 60.1006 33.8516H79V52.9616C71.5519 52.9616 53.977 52.9616 53.977 60.3116V77.1116L48.3468 76.2716ZM109.653 76.2716L111.316 48.083C111.772 40.3625 105.633 33.8516 97.8995 33.8516H79.0001V52.9616C88.3922 52.9616 104.023 52.9616 104.023 60.3116V77.1116L109.653 76.2716Z",
    fill: "#BFBEFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6645 79.1937C58.8136 86.0101 56.8642 94.0703 52.0592 94.8803C47.2541 95.6903 42.4274 90.8211 41.2783 84.0047C40.1292 77.1882 42.6826 71.4161 47.4877 70.6061C52.2927 69.7961 57.6645 72.2173 57.6645 79.1937Z",
    fill: "#BFBEFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.066 79.1937C98.9174 86.0101 100.867 94.0703 105.672 94.8803C110.477 95.6903 115.304 90.8211 116.453 84.0047C117.602 77.1882 115.048 71.4161 110.243 70.6061C105.438 69.7961 100.066 72.2173 100.066 79.1937Z",
    fill: "#BFBEFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.928 134.937C102.52 143.174 91.9633 149.772 78.9999 149.772C66.1672 149.772 55.6927 143.307 55.0875 135.185C51.8362 135.737 48.877 136.214 46.66 136.542C23.98 139.902 5.91992 151.452 5.91997 178.542L5.91992 223.902H78.7899H80.68H153.55L153.55 178.542C153.55 151.452 135.49 139.902 112.81 136.542C110.266 136.165 106.746 135.594 102.928 134.937Z",
    fill: "#A996FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_36238_20641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 134,
    width: 149,
    height: 90
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.928 134.937C102.52 143.174 91.9633 149.772 78.9999 149.772C66.1672 149.772 55.6927 143.307 55.0875 135.185C51.8362 135.737 48.877 136.214 46.66 136.542C23.98 139.902 5.91992 151.452 5.91997 178.542L5.91992 223.902H78.7899H80.68H153.55L153.55 178.542C153.55 151.452 135.49 139.902 112.81 136.542C110.266 136.165 106.746 135.594 102.928 134.937Z",
    fill: "#BFBEFC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_36238_20641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.381 123.732H153.654V227.052C153.654 227.052 91.2847 241.138 102.513 227.052C110.381 217.182 110.381 123.732 110.381 123.732Z",
    fill: "#A996FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1995 123.732H5.9264V227.052C5.9264 227.052 68.2958 241.138 57.0673 227.052C49.1994 217.182 49.1995 123.732 49.1995 123.732Z",
    fill: "#A996FF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0001 217.671L52.0001 217.671L52.0001 136.172C55.7134 152.362 67.8986 182.981 79 189.451C90.1015 182.981 102.287 152.362 106 136.172L106 217.671L83 217.671L75.0001 217.671Z",
    fill: "#EAAC30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.524 131.73L141.205 137.845L122.248 245.358L87.5662 239.243L106.524 131.73ZM51.2012 131.73L16.5197 137.845L35.4771 245.358L70.1586 239.243L51.2012 131.73Z",
    fill: "#EAAC30"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0869,
    y: 136.011,
    width: 14.0866,
    height: 109.171,
    transform: "rotate(-10 27.0869 136.011)",
    fill: "#FFF8E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 14.0866,
    height: 109.171,
    transform: "matrix(-0.984808 -0.173648 -0.173648 0.984808 130.963 136.011)",
    fill: "#FFF8E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4562 26.0572C107.547 31.9412 117.461 45.9639 117.461 62.3264C117.461 62.8299 117.452 63.3311 117.433 63.83C118.893 64.7749 119.887 66.3964 119.887 68.2781C119.887 70.4682 118.494 72.3796 116.351 72.8319C111.111 73.9379 99.6151 75.6719 79.0411 75.6719C58.4672 75.6719 46.971 73.9379 41.731 72.8319C39.5881 72.3796 38.1956 70.4682 38.1956 68.2781C38.1956 66.7547 38.847 65.4019 39.8696 64.4405C39.8328 63.7405 39.8142 63.0356 39.8142 62.3264C39.8142 45.9648 49.7277 31.9428 63.8167 26.0583C65.1899 22.943 68.2943 20.6719 72.0622 20.6719H85.2112C88.9787 20.6719 92.0828 22.9425 93.4562 26.0572Z",
    fill: "#EAAC30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/worker.0898c8380ad29537179bc51b5f208583.svg";
export { ForwardRef as ReactComponent };